import {
  FETCH_COACH_REQUEST,
  FETCH_COACH_SUCCESS,
  FETCH_COACH_FAILURE,
} from './coachTypes';

const initialState = {
  loading: false,
  coach: null,
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COACH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_COACH_SUCCESS:
      return {
        loading: false,
        coach: action.payload,
        error: '',
      };
    case FETCH_COACH_FAILURE:
      return {
        loading: false,
        coach: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
